import React from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../common/utils/xssFilter";

//temp component, before html is refactored
function ArticleOfferTitle(props) {
    const data = props.data ? props.data.properties || {} : null;
    if (!data) {
        return "";
    }
    const dataProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["value"]
    });

    return (
        <div className="un-article-content-panel un-article-content-panel-sm">
            <div className="tq-main-color-bg un-article-main-accent">
                <div className="un-article-main-accent-content">
                    <div className="tq-text-content">
                        <h1
                            dangerouslySetInnerHTML={{
                                __html: xssFilter.process(dataProps.value)
                            }}
                            data-hyperlinks-container={true}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default webui.connectComponent()(ArticleOfferTitle);
